module.exports = __webpack_public_path__ + "static/media/xray-training-kneecap-view4.129ce470.png";